module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/shop_miyakojima_01-22a6e54ae3577f43af54aaad5cc76335.jpg";